import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-code-gen-settings',
  templateUrl: './code-gen-settings.component.html',
  styleUrls: ['./code-gen-settings.component.scss']
})
export class CodeGenSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
